// extracted by mini-css-extract-plugin
export default {"componentWrapper":"DownloadExport_componentWrapper__MMfN9"};